module.exports = __webpack_public_path__ + "static/img/down.efd0ecd1.svg";